function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Speaker-(High)");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6,0L4,7H0.3a0.3,0.3,0,0,0-.3.3v9.4a0.3,0.3,0,0,0,.3.3H4l7.6,7a0.4,0.4,0,0,0,.4-0.4V0.4A0.4,0.4,0,0,0,11.6,0ZM15,7V17a5.49,5.49,0,0,0,3-5A5.49,5.49,0,0,0,15,7Zm3.86-4.85a1.5,1.5,0,1,0-1.71,2.46,9,9,0,0,1,0,14.78,1.5,1.5,0,0,0,1.72,2.46A12,12,0,0,0,18.86,2.15Z"
});

var SvgHigh = function SvgHigh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHigh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/high.5956fc0d.svg";
export { ForwardRef as ReactComponent };